import { truncate } from '@snapbrains/snaputils/src/strings';

import { formatMoney } from '@snapbrains/snaputils/src/money';

export const SNAPDEALIST_APP_ID = 1033;
export const SNAPLINKER_APP_ID = 1019;
export const SNAPSEARCHER_APP_ID = 1021;
export const SNAPVISI_APP_ID = 1025;

export function calculatePrice(result) {
  const calculated = {};
  if (result.dblProductSalePrice && result.dblProductPrice && result.dblProductPrice != result.dblProductSalePrice) {
    calculated.salePercent = Math.round((1 - (result.dblProductSalePrice / result.dblProductPrice)) * 100);
    calculated.saleClass = 'snapgadget-onsale';
    calculated.onSale = true;
  } else {
    calculated.salePercent = 0;
    calculated.saleClass = '';
    calculated.onSale = false;
  }
  calculated.price = result.dblProductPrice;
  return calculated;
}

export function productDescription(result) {
  return truncate(result.txtAbbreviatedDescription || result.txtLongDescription, 350, ' ...');
}

export function productImage(result, width = 0, height = 0) {
  let image = result.strThumbnailImage || result.strMediumImage || result.strLargeImage || '//www.snapsearcher.com/images/no_image.gif';
  if (width > 100 || height > 100) {
    image = result.strMediumImage || result.strLargeImage || '//www.snapsearcher.com/images/no_image.gif';
  }
  image = image.replace('http:', '');
  return image;
}

export function affiliateLinkForUrl(url, merchantId, avantlinkWebsiteId, trackingCode = '', appId = SNAPLINKER_APP_ID) {
  let affiliateUrl = `https://www.avantlink.com/click.php?tt=app&ti=${appId}`+
    `&mi=${merchantId}` +
    `&pw=${avantlinkWebsiteId}` +
    `&url=${encodeURIComponent(url)}`;

  if (trackingCode && trackingCode.length > 0) {
    affiliateUrl += `&ctc=${trackingCode}`;
  }

  return affiliateUrl;
}

export function productUrl(result, avantlinkWebsiteId, trackingCode = '', app_id = SNAPLINKER_APP_ID) {
  // Example url http://www.avantlink.com/click.php?tt=app&ti=52&pw=36893&mi=10060&pt=3&pri=568823
  let url = `http://www.avantlink.com/click.php?tt=app&ti=${app_id}` +
    `&pw=${avantlinkWebsiteId}` +
    `&mi=${result.lngMerchantId}` +
    `&df=${result.lngDatafeedId}` +
    `&pri=${result.lngProductId}`;

  // If the result was a saved from SnapLinker it won't contain lngProductId and lngDatafeedId.
  // Instead, the url generated by SnapLinker using affiliateLinkForUrl should be stored in strBuyURL so
  // return that value instead.
  if (!result.lngProductId && !result.lngDatafeedId && result.strBuyURL && result.strBuyURL.indexOf('tt=app') >= 0) {
    url = result.strBuyURL;
  }

  if (trackingCode && trackingCode.length > 0) {
    url += `&ctc=${trackingCode}`;
  }

  return url;
}

export function calculateCommission(result){
  var price = result.dblProductPrice;
  if(result.onSale){
    price = result.dblProductSalePrice;
  }

  const commission = parseFloat(result?.strActionCommission?.replace('%', ''));
  if (isNaN(commission)) {
    return '0.00';
  }
  return formatMoney(parseFloat(price) * commission * 0.01);
}
